// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"n7","tag":"n8","isRental":"n9","title":"n-","title2":"n_","description":"oa","cta":"ob","ratingLabel":"oc","ratingLabelSmallScreen":"od","iconInHotspotVideo":"oe"};